import Admin from "../Admin";
import React from "react";
import CardAccountGeneral from "../../../Component/Card/Admin/Accounts/CardAccountGeneral";
import CardAccountContact from "../../../Component/Card/Admin/Accounts/CardAccountContact";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from '@mui/material/MenuItem';
import MUIListItemIcon from '@mui/material/ListItemIcon';
import Validator from "../../../Utility/Validator";
import Account from "../../../Utility/Crud/Account";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
import api from "../../../Seating/Security/api";
import moment from "moment";

export default class AccountCreateEdit extends Admin {
    constructor(props) {
        super(props);

        this.state.account = null;
        this.state.newAccount = {
            name: "",
            accountType: {},
            owner: {},
            ownerId: null,
            city: "",
            state: "",
            zip: "",
            phoneNumber: "",
            faxNumber: "",
            email: "",
            zip: "",
            notes: null,
            locationId: null,
            isTarget: false,
        };
        this.state.isProcessing = false;
        this.state.isUpdate = !!props.match.params.id;
        this.state.confirmDialogOpen = false;
        this.state.validationIssues = {};
    }


    /**
     * Set the account in the state.
     */
    async afterComponentDidMount() {
        const accountId = this.props.match.params.id ? +this.props.match.params.id : null;

        if (accountId !== null) {
            const account = await api.send("GET", `/sources/${accountId}`).then((data) => data);
            this.setState({
                account: account,
            });
        } else {
            const { currentUser } = this.context;
            let newAccount = this.state.newAccount;
            const ownerLocations = Object.values(this.context.userprofileLocationsIndexed)
                .filter((userprofileLocation) => userprofileLocation.userprofileId === currentUser.id)
                .map((userprofileLocation) => this.context.locationsIndexed[userprofileLocation.locationsId])
                .filter((location) => location != null);

            newAccount.owner = { id: currentUser.id, username: currentUser.username };
            newAccount.ownerId = currentUser.id;
            newAccount.locationId = ownerLocations.length === 1 ? ownerLocations[0].id : null;

            this.setState({ account: newAccount });
        }
    }

    /**
     * Creates the Account with the current properties in state.account.
     */
    async createAccount() {
        this.setState({
            isProcessing: true,
        });

        return api.send("POST", "/sources", this.state.account)
            .then((data) => {
                this.props.history.push(`/account/${data.id}/detail`);
                NotistackEnqueueSnackbar("Account created successfully!", { variant: "success" });
                this.setState({
                    isProcessing: false,
                });
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error creating a new Account.", { variant: "error" });
                this.setState({
                    isProcessing: false,
                });
            });
    }

    /**
     * Updates the Account with the current properties in state.account.
     */
    async updateAccount() {
        this.setState({
            isProcessing: true,
        });

        const promises = [];

        promises.push(
            api.send("PUT", `/sources/`, this.state.account)
        );

        return Promise.all(promises)
            .then(() => {
                this.props.history.push(`/account/${this.state.account.id}/detail`);
                NotistackEnqueueSnackbar("Account updated successfully!", { variant: "success" });
                this.setState({
                    isProcessing: false,
                });
            })
            .catch(err => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error updating the Account", { variant: "error" });
                this.setState({
                    isProcessing: false,
                });
            });
    }

    /**
     * Marks the account as deleted.
     */
    async deleteAccount() {
        this.setState({
            isProcessing: true,
        });
        const { currentUser } = this.context;
        const deletedAccount = this.state.account;

        deletedAccount.deletedAt = new moment().toISOString();
        deletedAccount.deleted = true;
        deletedAccount.deletedById = currentUser.id;

        return api.send("DELETE", `/accounts/${this.state.account.id}`)
            .then(() => {
                this.props.history.push(`/reports/accounts`);
                NotistackEnqueueSnackbar("Account deleted successfully!", { variant: "success" });
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Oh no! There was an error deleting the Account.", { variant: "error" });
                this.setState({
                    confirmDialogOpen: false,
                });
            });

    }

    /**
     * Render the content.
     */
    renderContent() {
        const handleChange = (account) => {
            this.setState({
                account: {
                    ...this.state.account,
                    ...account,
                },
            });
        };

        return (
            <>
                <CardAccountGeneral
                    account={this.state.account}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <CardAccountContact
                    account={this.state.account}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <DialogConfirm
                    open={this.state.confirmDialogOpen}
                    onClose={() => this.setState({ confirmDialogOpen: false })}
                    onConfirm={() => this.deleteAccount()}
                    text="Are you sure you want to delete this account? This cannot be undone."
                    header="Delete Account"
                    loading={this.state.isProcessing}
                />
            </>
        );
    }

    /**
    * Render the header.
    */
    renderHeader() {
        let title;
        let subtitle;
        const buttonText = this.state.isUpdate ? "Save" : "Create";

        if (!this.state.isUpdate) {
            title = 'Create Account';
            subtitle = null;
        } else {
            title = 'Edit Account';
            subtitle = (this.state.account && (Account.getDisplayName(this.state.account) + " • " + this.state.account.id));
        }

        const handleClickBack = () => {
            this.props.history.goBack();
        };

        const handleClickSave = () => {
            const validationIssues = Validator.validate(
                this.state.account,
                {
                    name: {
                        'required': true
                    },
                    addrLine1: {
                        'required': true
                    },
                    city: {
                        'required': true
                    },
                    state: {
                        'required': true
                    },
                    locationId: {
                        'required': true
                    },
                    zip: {
                        'type': 'zipCode',
                        'required': true,
                    },
                    ownerId: {
                        'required': true
                    },
                    phoneNumber: {
                        'type': 'phone',
                        'required': true,
                    },
                    faxNumber: {
                        'type': 'phone',
                    },
                    accountTypeId: {
                        'required': true
                    }
                }
            );

            this.setState({
                validationIssues: validationIssues,
            });

            if (Object.keys(validationIssues).length === 0) {
                if (this.state.isUpdate) {
                    this.updateAccount();
                } else {
                    this.createAccount();
                }
            } else {
                NotistackEnqueueSnackbar("Please correct the displayed issues.", { variant: "error" });
            }

        };

        const handleDelete = () => {
            this.setState({
                confirmDialogOpen: true,
            });
        };

        const buttons = [
            (this.props.history.length !== 1 ? <MUIButton onClick={handleClickBack}>Back</MUIButton> : <></>),
            (
                <MUILoadingButton
                    loading={this.state.isProcessing}
                    loadingPosition="start"
                    onClick={handleClickSave}
                    variant="contained"
                    startIcon={<MUISaveButton />}>
                    {buttonText}
                </MUILoadingButton>
            )
        ];

        if (this.state.isUpdate) {
            const menuItems = [
                (
                    <MUIMenuItem onClick={handleDelete}>
                        <MUIListItemIcon>
                            <MUIDeleteIcon fontSize="small" />
                        </MUIListItemIcon>
                        Delete
                    </MUIMenuItem>
                )
            ];
            buttons.push((<Menu menuItems={menuItems} />));
        }

        return (
            <PageHeader title={title} subtitle={subtitle} buttons={buttons} />
        );
    }
}
